module.exports = {
    OBJECT_TYPE: Object.freeze({
        ADMINISTRATOR: 'administrator',
        ADDRESS: 'address',
        CATEGORY: 'category',
        CUSTOMER: 'customer',
        GROCER: 'grocer',
        GROCER_CATEGORY: 'grocer_category',
        GOODS: 'goods',
        PAGE_SETTINGS: 'page_settings',
        PARTNER: 'partner',
        PHARMACY: 'pharmacy',
        PHARMACY_CATEGORY: 'pharmacy_category',
        DRUG: 'drug',
        PROMOTION: 'promotion',
        PROMOTION_CLIENT: 'promotion_client',
        RESTAURANT: 'restaurant',
        DISH: 'dish',
        INGREDIENT: 'ingredient',
        MODIFIER: 'modifier',
        SETTINGS: 'settings',
        PROMOCODE: 'promocode',
    }),
    OPERATION_TYPE: Object.freeze({
        CREATE: 'create',
        UPDATE: 'update',
        DELETE: 'delete',
        REORDER: 'reorder',
        PASSWORD: 'password',
        SETTINGS: 'settings',
        LOGIN: 'login',
        IMPORT: 'import',
        CATEGORIES: 'categories',
        APPLY: 'apply',
    }),
};
